<template>
  <div class="reports__data mt-8">
    <v-data-table
      class="data__table"
      ref="table"
      :headers="headers"
      :items="data"
      fixed-header
      hide-default-footer
      disable-pagination
      must-sort
      :mobile-breakpoint="mobileBreakpoint"
    >
    <template v-slot:item.location_name="{ item }">
        <span>{{ item.location_name }}</span>
    </template>
    <template v-slot:item.discount_percentage="{ item }">
        <span>{{ `${item.discount_percentage}%` }}</span>
    </template>
    <template v-slot:item.discount_list_name="{ item }">
        <span>{{ item.discount_list_name }}</span>
    </template>
    <template v-slot:item.product_name="{ item }">
        <span>{{ productName(item.product_name) }}</span>
    </template>
    </v-data-table>
  </div>
</template>

<script>
import auth from '@/auth'

export default {
  name: 'DataTableDiscountLocations',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      auth: auth,
      headers: [
        {text: 'Locaiton name', value: 'location_name'},
        { text: 'Discount', value: 'discount_percentage' },
        { text: 'Discount list name', value: 'discount_list_name' },
        { text: 'Product', value: 'product_name' }
      ],
      mobileBreakpoint: 767 // screen width in pixel to switch to mobile view
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth <= this.mobileBreakpoint
    }
  },
  methods: {
    productName(name) {
      return 'Visitor parking'
    }
  }
}
</script>
<style lang="scss" scoped>
.reports__data .theme--light:focus:before {
  opacity: 1 !important;
}

::v-deep .tooltip-column {
  max-width: 145px;
}
::v-deep .ellipsed-text {
  width: 100%;
  display: block;
  overflow: hidden;
  text-wrap: nowrap;
  text-overflow: ellipsis;
}

::v-deep th {
  text-wrap: nowrap;
}
</style>
